import vehicleService from "../../service/vehicle.service";
import {
  mapEmbeddedReboquesToApiPayload,
  normalizeTrailerIds,
} from "./reboque-trailer-utils";

/**
 * Persiste lista de reboques legados no trator.
 * Recebe o array já patchado (evita stale closure no caller).
 *
 * @returns {Promise<{ nextReboques: object[], persisted: boolean }>}
 */
export async function saveEmbeddedReboqueOnTractor({
  tractorId,
  reboques,
  trailerIds,
  isStarted,
}) {
  const nextReboques = Array.isArray(reboques) ? reboques : [];
  const id = String(tractorId || "").trim();
  if (!id || id === "undefined") {
    return { nextReboques, persisted: false };
  }

  await vehicleService.update(id, {
    reboques: mapEmbeddedReboquesToApiPayload(nextReboques, isStarted),
    trailerIds: normalizeTrailerIds(trailerIds),
  });

  return { nextReboques, persisted: true };
}
